let listeners = [];
let idCounter = 0;

export const ToastType = {
  info: "info",
  success: "success",
  error: "error"
};

export function subscribe(listener) {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter(l => l !== listener);
  };
}

function emit(toast) {
  listeners.forEach(l => l(toast));
}

function show(message, type = ToastType.info, options = {}) {
  const id = ++idCounter;
  emit({ id, message, type, ...options });
  return id;
}

function info(message, options) {
  return show(message, ToastType.info, options);
}

function success(message, options) {
  return show(message, ToastType.success, options);
}

function error(message, options) {
  return show(message, ToastType.error, options);
}

export const toast = { show, info, success, error };
